/**
 * Resolves a user id to the name a reader sees.
 *
 * @module components/shared/user-display-name
 */

export const FORMER_MEMBER = "Former member";

interface NamedUser {
  id: string;
  displayName: string;
}

/**
 * Known name, else the session user's own, else "Former member". When the
 * workspace read failed the list is empty for a reason other than departure,
 * so an unknown id stays as the id.
 */
export function userDisplayName(
  userId: string,
  {
    users = [],
    self = undefined,
    namesUnavailable = false,
  }: {
    users?: readonly NamedUser[];
    self?: { id: string; displayName?: string };
    namesUnavailable?: boolean;
  },
): string {
  return (
    users.find((user) => user.id === userId)?.displayName ??
    (self?.id === userId ? self.displayName : undefined) ??
    (namesUnavailable ? userId : FORMER_MEMBER)
  );
}
